import React from 'react';
import LazyImage from '../lazy-image';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';

export default function CaseStudyLargeImage({ image }: { image: any }) {
  return <LazyImage fluid={getFluidGatsbyImage(image)} alt={image.alt} />;
}
